type SessionPayload = Record<string, unknown> | null;

const ACTIVE_SUBSCRIPTION_STATUSES = new Set(["active", "trialing"]);

export function getSubscriptionStatus(session: SessionPayload): string | null {
  if (!session) return null;
  const direct = session.subscription_status as string | undefined;
  if (direct) return direct;
  const organization = session.organization as Record<string, unknown> | undefined;
  const orgStatus =
    (organization?.stripe_subscription_status as string | undefined) ??
    (organization?.subscription_status as string | undefined);
  return orgStatus ?? null;
}

export function hasActiveSubscription(session: SessionPayload): boolean {
  const status = getSubscriptionStatus(session);
  return status ? ACTIVE_SUBSCRIPTION_STATUSES.has(status) : false;
}

export function isBillingExempt(session: SessionPayload): boolean {
  if (!session) return false;
  const direct = Boolean(session.billing_exempt);
  const organization = session.organization as Record<string, unknown> | undefined;
  const user = session.user as Record<string, unknown> | undefined;
  return direct || Boolean(organization?.billing_exempt) || Boolean(user?.billing_exempt);
}

export function requiresBillingBeforeOnboarding(session: SessionPayload): boolean {
  if (!session) return false;
  const isOnTrial = Boolean(session.is_on_trial);
  const isOwner = Boolean((session.user as Record<string, unknown> | undefined)?.is_owner);
  if (isOnTrial || isOwner) return false;
  if (isBillingExempt(session)) return false;
  return !hasActiveSubscription(session);
}

export function needsBillingContextRefresh(session: SessionPayload): boolean {
  if (!session) return false;
  const hasTrialFlag =
    "is_on_trial" in session || "trial_ends_at" in session || "trial_expired" in session;
  const hasSubscriptionFlag =
    "subscription_status" in session ||
    Boolean((session.organization as Record<string, unknown> | undefined)?.stripe_subscription_status) ||
    Boolean((session.organization as Record<string, unknown> | undefined)?.subscription_status);
  return !(hasTrialFlag && hasSubscriptionFlag);
}
